import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { FormGroup, FormArray, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

// reactive
import { distinctUntilChanged, startWith, map, debounceTime } from 'rxjs/operators';

// services
import { QuestionService } from '../../services/question.service';

// utilities
import { forEach, find } from 'lodash';

@Component({
  selector: 'beneficiary-allocation',
  templateUrl: './beneficiary-allocation.component.html',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: BeneficiaryAllocationComponent,
    multi: true
}],
})
export class BeneficiaryAllocationComponent implements OnInit, ControlValueAccessor {
    @Input() form: FormGroup;
    @Input() type: string;
    @Input() isEditable: boolean;
    onChange: any = () => { };
    onTouched: any = () => { };
    totalAllocation: any = 0;
    show: boolean = false;
    arrayLength: number = 0;

    constructor(
        private changeDetector: ChangeDetectorRef,
        private questionService: QuestionService
    ) { }

    ngOnInit() {
        // initialize show property
        this.show = this.type == 'Primary' ? true : false;

        // add listener
        this.BeneficiaryInformation.valueChanges
        .pipe(
            startWith(this.BeneficiaryInformation),
            map((items) => {
                return items.length;
            }),
            distinctUntilChanged()
        ).subscribe((value) => {
            // inner subscription
            forEach(this.BeneficiaryInformation.controls, (control: any) => {

                // total allocation calculation
                control.get('BeneficiaryPercentage').valueChanges
                    .pipe(debounceTime(500), distinctUntilChanged())
                    .subscribe((_value) => {
                        this.totalAllocation = this.questionService.calculateTotalAllocationType(this.BeneficiaryInformation.getRawValue(), 'BeneficiaryPercentage', this.type);
                        this.onChange(this.totalAllocation);
                        this.changeDetector.markForCheck();
                    });

                // show bar if necessary
                control.get('BeneficiaryPrimaryOrSecondary').valueChanges
                    .pipe(debounceTime(500), distinctUntilChanged())
                    .subscribe((__value) => {
                        this.totalAllocation = this.questionService.calculateTotalAllocationType(this.BeneficiaryInformation.getRawValue(), 'BeneficiaryPercentage', this.type);
                        this.onChange(this.totalAllocation);
                        this.changeDetector.markForCheck();

                        if (__value && this.type == "Secondary") {
                            const secondary = find(this.BeneficiaryInformation.getRawValue(), {BeneficiaryPrimaryOrSecondary: "Secondary"});
                            this.show = secondary ? true : false;

                            this.totalAllocation = this.questionService.calculateTotalAllocationType(this.BeneficiaryInformation.getRawValue(), 'BeneficiaryPercentage', this.type);
                            this.onChange(this.totalAllocation);
                            this.changeDetector.markForCheck();
                        }
                    });
            });

            // check for closed child resposne and recalculate percentage
            if (this.BeneficiaryInformation.controls.length < this.arrayLength) {
                this.totalAllocation = this.questionService.calculateTotalAllocationType(this.BeneficiaryInformation.value, 'BeneficiaryPercentage', this.type);
                this.onChange(this.totalAllocation);
                this.changeDetector.markForCheck();
            }
            this.arrayLength = this.BeneficiaryInformation.controls.length;

        })

        this.isEditable = this.isEditable == null ? true : this.isEditable;
    }

    get BeneficiaryInformation(): FormArray {
        return this.form.get('BeneficiaryInformation') as FormArray;
    }

    // Control Value Accessor interface
    writeValue(value: string) {
        this.totalAllocation = value;
        this.changeDetector.markForCheck();
    }

    // Control Value Accessor interface
    registerOnChange(fn: any) {
        this.onChange = fn;
    }

    // Control Value Accessor interface
    registerOnTouched(fn: any) {
        this.onTouched = fn;
    }
}
